import styled from 'styled-components'

import { Typography } from 'primsell-shared-layer/components/atoms/typography'

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 600;
`

export const Description = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
  margin-bottom: 24px;
  max-width: 391px;
  white-space: pre-line;
`
